import Tooltip from 'apollo-react/components/Tooltip';
import React from 'react';

import { useTranslation } from '../../../../../custom-hooks/useTranslation';
import { getTooltipText } from '../../../../utils/entity-designer.utils';

const CustomTooltip = ({ prop, children }) => {
  const translateString = useTranslation();
  const tooltipText = getTooltipText(prop);

  return tooltipText ? (
    <Tooltip title={translateString(tooltipText)}>{children}</Tooltip>
  ) : (
    <>{children}</>
  );
};
export default CustomTooltip;
